export default [
  {
      path: '/',
      name: 'homepage',
      redirect:'/homepage',
      meta: { login:false },
  },
  {
    path: '/myProfile',
    name: 'myProfile',
    meta: { title:'我的资料',login:true },
    component: () => import(/* webpackChunkName: 'myProfile' */ './page/myProfile.vue'),
  },
  {
    path: '/editProfile',
    name: 'editProfile',
    meta: { login:false },
    component: () => import(/* webpackChunkName: 'editProfile' */ './page/editProfile.vue'),
  }
  
]